import { PageTitle } from "./PageTitle";
export default PageTitle;
export * from "./PageTitle";
